import { Modal, ModalFuncProps } from "antd";
import { ReactNode } from "react";

// Функция для передачи в блок catch Api методов: пробрасывает ошибки и показывает сообщение об ошибке в модалке
export const catchApiError = (props: {
  e: any;
  title: ReactNode;
  onOk?: () => void;
  hideErrorModal?: true;
  modalWidth?: number;
}) => {
  const { e, title, onOk = () => {}, hideErrorModal, modalWidth } = props;
  const errorOptions: ModalFuncProps = {
    title,
    content: "Что-то пошло не так... ",
    onOk,
  };
  if (modalWidth) {
    errorOptions.width = modalWidth;
  }
  const errorMessage = e?.response?.data.message;
  if (errorMessage) {
    errorOptions.content = errorMessage;
  }
  if (hideErrorModal) {
    console.error(errorOptions);
  } else {
    Modal.error(errorOptions);
  }
  throw new Error(errorOptions.content?.toString()); // TODO. Переделать, чтобы ошибка была обработана
};
